import { WavyEdge } from 'components/flair/WavyEdge';
import React from 'react';
import { Colors } from 'web-common/src/shared/styles';

const DEFAULT_FREQUENCY = 8;
const DEFAULT_AMPLITUDE = 8;
const DEFAULT_COLOR = Colors.GRAY_LITE_20;
const DEFAULT_BACKGROUND = Colors.WHITE;

interface IProps {
  className?: string;
  frequency?: number;
  amplitude?: number;
  borderColor?: string;
  backgroundColor?: string;
}

export const WavyDivider: React.FC<IProps> = ({ className, frequency, amplitude, borderColor, backgroundColor }) => {
  return (
    <div className={`relative h-0 w-full ${className}`}>
      <div className='absolute top-0 h-0 w-full'>
        <WavyEdge
          color={borderColor ?? DEFAULT_COLOR}
          frequency={frequency ?? DEFAULT_FREQUENCY}
          amplitude={amplitude ?? DEFAULT_AMPLITUDE}
        />
      </div>
      <div className='absolute top-px h-0 w-full'>
        <WavyEdge
          color={backgroundColor ?? DEFAULT_BACKGROUND}
          frequency={frequency ?? DEFAULT_FREQUENCY}
          amplitude={amplitude ?? DEFAULT_AMPLITUDE}
        />
      </div>
    </div>
  );
};
